import React, { useEffect, useRef } from 'react';
import {
    ModalV2,
    ModalV2Title,
    ModalV2Content,
    ModalV2Footer,
    ButtonGroup,
    Button,
    LoaderMi,
    InputControl,
    Container,
    Row,
    Col,
} from '@design-system-etat/dsfr-react';
import { useForm } from 'react-hook-form';
import { getAPI, postAPI, reinitialiseAPI } from 'store/apiReducer';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import usagerClientReducer from '../../../../store/usagerReducer';
import {
    API_RECUPER_LOGIN_REPONSE,
    API_RECUPER_LOGIN_VALIDER_TOKEN,
    CONTEXT_RECUPER_LOGIN_REPONSE,
    CONTEXT_RECUPER_LOGIN_VALIDER_TOKEN,
} from '../../../../constants/apiUrls.constants';

const QuestionsLoginOublie = ({
    postApi,
    getApi,
    reinitialiseApi,
    isLoadingToken,
    erreurToken,
    messageToken,
    dataToken,
    isLoadingReponse,
    erreurReponse,
    messageReponse,
    dataReponse,
}) => {
    const { register, handleSubmit, formState } = useForm({
        mode: 'onChange',
        criteriaMode: 'all',
    });
    const { token } = useParams();

    useEffect(() => {
        getApi(
            usagerClientReducer,
            API_RECUPER_LOGIN_VALIDER_TOKEN.replace('{token}', token),
            CONTEXT_RECUPER_LOGIN_VALIDER_TOKEN,
        );
    }, []);

    useEffect(() => {
        return () => {
            reinitialiseApi(CONTEXT_RECUPER_LOGIN_VALIDER_TOKEN);
            reinitialiseApi(CONTEXT_RECUPER_LOGIN_REPONSE);
        };
    }, []);

    const redirigerVersAccueil = () => {
        window.location.href = process.env.REACT_APP_HOST;
    };

    const onSubmit = (dataForm) => {
        const response = {
            token,
            reponses: dataForm,
        };

        postApi(
            usagerClientReducer,
            API_RECUPER_LOGIN_REPONSE,
            response,
            CONTEXT_RECUPER_LOGIN_REPONSE,
        );
    };

    const dialog = useRef();

    useEffect(() => {
        if (dialog.current) {
            dialog.current.showModal();
        }
    }, [dialog]);

    return (
        <Container>
            {erreurToken && (
                <ModalV2
                    id="tokenInvalide"
                    idModalTitle="tokenInvalide-title"
                    size="sm"
                    onClose={redirigerVersAccueil}
                    ref={dialog}
                >
                    <ModalV2Content>
                        <ModalV2Title id="tokenInvalide-title">Token Invalide</ModalV2Title>
                        {messageToken}
                    </ModalV2Content>
                    <ModalV2Footer>
                        <ButtonGroup align="right" inline>
                            <Button variant="primary" onClick={redirigerVersAccueil}>
                                Retour
                            </Button>
                        </ButtonGroup>
                    </ModalV2Footer>
                </ModalV2>
            )}

            {dataReponse && (
                <ModalV2
                    id="affichageLogin"
                    idModalTitle="affichageLogin-title"
                    size="sm"
                    onClose={redirigerVersAccueil}
                    ref={dialog}
                >
                    <ModalV2Content>
                        <ModalV2Title id="affichageLogin-title">Récupération de Login</ModalV2Title>
                        Votre login est : {dataReponse}
                    </ModalV2Content>
                    <ModalV2Footer>
                        <ButtonGroup align="right" inline>
                            <Button variant="primary" onClick={redirigerVersAccueil}>
                                <span>Retour à la page de connexion</span>
                            </Button>
                        </ButtonGroup>
                    </ModalV2Footer>
                </ModalV2>
            )}

            {erreurReponse && (
                <ModalV2
                    size="sm"
                    onClose={() => {
                        reinitialiseApi(CONTEXT_RECUPER_LOGIN_REPONSE);
                    }}
                    id="erreurRecuperationLogin"
                    idModalTitle="erreurRecuperationLogin-title"
                    ref={dialog}
                >
                    <ModalV2Title id="erreurRecuperationLogin-title">
                        Erreur lors de la récupération du login
                    </ModalV2Title>
                    <ModalV2Content>{messageReponse}</ModalV2Content>
                    <ModalV2Footer>
                        <ButtonGroup align="right" inline>
                            <Button
                                variant="primary"
                                onClick={() => {
                                    reinitialiseApi(CONTEXT_RECUPER_LOGIN_REPONSE);
                                }}
                            >
                                Retour
                            </Button>
                        </ButtonGroup>
                    </ModalV2Footer>
                </ModalV2>
            )}

            <h1 className="text-center majuscule">Identifiant Oublié</h1>

            <div className="bordure">
                {isLoadingToken && <LoaderMi />}
                <h2 className="font-size-md text-center margin-top-sm margin-bottom-md">
                    Vous avez perdu votre identifiant. Veuillez suivre la procédure ci-dessous pour
                    le récupérer
                </h2>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Row gutters horizontalAlign="center" className="margin-bottom-md">
                        <Col col={12} md={8}>
                            {dataToken &&
                                dataToken.questions.map((question) => {
                                    return (
                                        <InputControl
                                            autocomplete="username"
                                            label={question.question}
                                            type="text"
                                            required
                                            {...register(question.identifiant, {
                                                required: 'Le champ est obligatoire',
                                            })}
                                            error={
                                                formState.errors
                                                    ? formState.errors[question.identifiant]
                                                    : null
                                            }
                                        />
                                    );
                                })}
                        </Col>
                    </Row>
                    <ButtonGroup className="margin-top-md" inline align="right">
                        <Button
                            name="retour-accueil"
                            variant="secondary"
                            onClick={redirigerVersAccueil}
                        >
                            Annuler
                        </Button>
                        <Button
                            name="valider"
                            variant="primary"
                            type="submit"
                            disabled={!formState.isValid}
                            isLoading={isLoadingReponse}
                        >
                            Valider
                        </Button>
                    </ButtonGroup>
                </form>
            </div>
            <br />
        </Container>
    );
};

QuestionsLoginOublie.propTypes = {
    postApi: PropTypes.func.isRequired,
    getApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    isLoadingToken: PropTypes.bool,
    erreurToken: PropTypes.bool,
    messageToken: PropTypes.string,
    dataToken: PropTypes.object,
    isLoadingReponse: PropTypes.bool,
    erreurReponse: PropTypes.bool,
    messageReponse: PropTypes.string,
    dataReponse: PropTypes.object,
};

export default connect(
    (state) => {
        const {
            erreur: erreurReponse,
            message: messageReponse,
            isLoading: isLoadingReponse,
            data: dataReponse,
        } = state.compte.recupererLogin.reponse;
        const {
            erreur: erreurToken,
            message: messageToken,
            isLoading: isLoadingToken,
            data: dataToken,
        } = state.compte.recupererLogin.validation;
        return {
            erreurToken,
            messageToken,
            isLoadingToken,
            dataToken,
            erreurReponse,
            messageReponse,
            isLoadingReponse,
            dataReponse,
        };
    },
    {
        postApi: postAPI,
        getApi: getAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(QuestionsLoginOublie);
